import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormInput from '../../../../library/form/components/FormInput';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormDialog from '../../../../library/form/components/FormDialog';
import FormTitle from '../../../../library/form/components/FormTitle';
import { UiGridColOne, UiCol } from "../../../../library/layout/Index";

const CurrencyHeaderEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }}
            formStyle={{ width: '400px', height: '500px' }}
            contentStyle={{ height: '185px', overflowY: "scroll" }}
            formTitle={<FormTitle formObject={formObject} value='Currency Detail' />}
            formObject={formObject} >
            <div>
                <UiGridColOne>
                    <UiCol>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "currencyId" }} className="uiLbl" value="Currency ID" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "currencyId" }} className="uiVal" />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "currencyName" }} className="uiLbl" value="Currency Name" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal uiVal50p"
                                    action={{ InputType: "input", paramName: "currencyName" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "currencyShortName" }} className="uiLbl" value="Currency Short Name" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal uiVal50p"
                                    action={{ InputType: "input", paramName: "currencyShortName" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "currencySymbol" }} className="uiLbl" value="Currency Symbol" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal uiVal50p"
                                    action={{ InputType: "input", paramName: "currencySymbol" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "currencyToWordTpl" }} className="uiLbl" value="To Word Template" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal uiVal50p"
                                    action={{ InputType: "input", paramName: "currencyToWordTpl" }} />
                            </li>
                        </ul>
                    </UiCol>
                </UiGridColOne>
            </div>
        </FormDialog>
    )
}

export default withView(CurrencyHeaderEditor, "currencyHead", "currencyHead")